// frontend/src/components/PageLoadingFallback.js

import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * Loading fallback for React.lazy() code-split pages.
 * Shows centered spinner while page chunk loads.
 */
function PageLoadingFallback() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
}

export default PageLoadingFallback;
